import React, { useState } from "react";
import Modal from "../Modal";
import ReactWhatsapp from "react-whatsapp";

function SendWpMsgOnNumModal({ title, onCloseHandler, message }) {
  const [contact, setContact] = useState("");
  return (
    <div>
      <Modal title={title} onCloseHandler={() => onCloseHandler()}>
        <div className="linkFamily_modal_container">
          <p>
            We were trying to wish, but you have not provided the contact
            details. Please, provide the WhatsApp contact number !
          </p>
          <label style={{ color: "black" }}>Phone Number:</label>
          <br />
          <input
            type="text"
            placeholder="eg-8273818293"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
          />

          <br />
          <label>Message Preview: </label>
          <br />
          <p>{message}</p>

          <br />
          <ReactWhatsapp
            number={contact}
            message={message}
            className="whatsapp_message_custom_btn"
          >
            send message
          </ReactWhatsapp>
        </div>
      </Modal>
    </div>
  );
}

export default SendWpMsgOnNumModal;
